import React from 'react'
import helpers from 'core/helpers'

interface DndDraggableProps {
    tag?: keyof JSX.IntrinsicElements
    wrapperComponent?: React.ReactElement
    dragEnabled?: boolean
    isMobileDragEnabled?: boolean
    type?: string
    data?: any
    onDragStart?: (event: React.DragEvent) => void
    onDragEnd?: (event: React.DragEvent) => void
    onClick?: (e: React.MouseEvent) => void
    children?: React.ReactNode
    className?: string
    style?: {
        backgroundSize?: string
        backgroundImage?: string
    }
}

interface DndDraggableState {
    isDragActions: boolean
}

class DndDraggable extends React.Component<DndDraggableProps, DndDraggableState> {
    static defaultProps: Partial<DndDraggableProps> = {
        type: 'dnd_item',
        dragEnabled: true,
        tag: 'div',
    }

    state: DndDraggableState = {
        isDragActions: false,
    }

    render() {
        let Tag: keyof JSX.IntrinsicElements = this.props.tag || 'div'
        let props: any = Object.assign({}, this.props)

        if (this.props.wrapperComponent) {
            Tag = this.props.wrapperComponent.type as keyof JSX.IntrinsicElements
            props = Object.assign(props, this.props.wrapperComponent.props)
            delete props.wrapperComponent
        }

        if (this.props.dragEnabled) {
            props.draggable = 'true'
            props.onDragEnd = this.onDragEnd.bind(this)
            props.onDragStart = this.onDragStart.bind(this)
        }

        if (this.props.dragEnabled && this.props.isMobileDragEnabled && helpers.isMobileDevice()) {
            props.onClick = () => {
                this.setState({ isDragActions: true })
            }

            if (!this.state.isDragActions) {
                delete props.draggable
            }
        }
        delete props.dragEnabled
        delete props.isMobileDragEnabled

        return <Tag {...props}>{props.children}</Tag>
    }

    onDragStart(e: React.DragEvent): void {
        if (typeof this.props.onDragStart === 'function') {
            this.props.onDragStart(e)
        }

        let props = Object.assign({}, this.props)
        if (this.props.wrapperComponent) {
            props = Object.assign(props, this.props.wrapperComponent.props)
        }
        e.dataTransfer.setData(props.type || 'dnd_item', props.data)
    }

    onDragEnd(e: React.DragEvent): void {
        if (typeof this.props.onDragEnd === 'function') {
            this.props.onDragEnd(e)
        }

        if (this.state.isDragActions) {
            this.setState({ isDragActions: false })
        }
    }
}

export default DndDraggable
